<div class="reporting-header-wrapper">
  <div class="white-box" *ngIf="loading; else showHeader">
    <div class="loading"></div>
  </div>
  <ng-template #showHeader>
    <div class="reporting-header" *ngIf="customer && endValues">
      <div class="reporting-header-item" *ngIf="daysDifference === 0; else endValue">
        <p class="big">
          {{ currentAccount?.currency }} <span>{{ currentAccount?.current_amount | translateNumber: customer?.language }}</span>
        </p>
        <p class="subtitle">{{ 'performance.header.current_value' | translate }}</p>
      </div>
      <ng-template #endValue>
        <div class="reporting-header-item">
          <p class="big">
            {{ currentAccount?.currency }} <span>{{ endValues?.end_value | translateNumber: customer?.language }}</span>
          </p>
          <p class="subtitle">{{ 'performance.table.endval' | translate }}</p>
          <p class="subtitle small">({{ 'performance.header.as_of' | translate: { date: endValues?.end_date } }})</p>
        </div>
        <div class="reporting-header-item">
          <p class="medium">
            {{ currentAccount?.currency }}
            <span>{{ endValues?.profit_all | translateNumber: customer?.language }}</span>
          </p>
          <p class="subtitle with-tooltip">
            {{ 'performance.table.profit' | translate }}
          </p>
        </div>
        <div class="reporting-header-item">
          <p class="medium">
            {{ currentAccount?.currency }} <span>{{ endValues?.deposits_value | translateNumber: customer?.language }}</span>
          </p>
          <p class="subtitle">{{ 'performance.table.your_investments' | translate }}</p>
        </div>
        <div class="reporting-header-item">
          <p class="medium">
            {{ currentAccount?.currency }} <span>{{ endValues?.withdrawal_all | translateNumber: customer?.language }}</span>
          </p>
          <p class="subtitle">{{ 'performance.table.your_withdrawals' | translate }}</p>
        </div>
      </ng-template>
    </div>
  </ng-template>
</div>
